import httpContext from '@rover/rsdk/src/modules/Network/httpContext';

import getRequestOrigin from './getRequestOrigin';

/**
 * Get the canonical URL for the current request or browser location.
 * A canonical URL doesn't have any query parameters or fragments,
 * i.e on rover.com/careers/engineering/?foo=bar#hashtag the canonical URL would be rover.com/careers/engineering
 */
const getCanonicalUrl = (): string => {
  if (process.env.JS_ENV_SERVER) {
    const requestOrigin = getRequestOrigin();
    const req = httpContext.getReq();
    if (!req) throw new Error('Cannot get canonical URL without a request object');

    // there is also a req.baseUrl, but we don't seem to use the base URL anywhere.
    // If we did, we would want to do req.baseUrl + req.path
    const { path } = req;
    return `${requestOrigin}${path}`;
  }

  if (process.env.JS_ENV_CLIENT) {
    // exclude the query string and hash present in window.location.href
    const { origin, pathname } = window.location;
    return `${origin}${pathname}`;
  }

  // Should be unreachable - are we not in an SSR or browser environment?
  throw new Error('Could not determine canonical URL');
};

export default getCanonicalUrl;
